export default {
  nav: {
    module: "Modules",
    moduleUser: "User settings",
    settingsModule: "Module settings",
    settingsClient: "System settings"
  },

  userModules: {
    myAccount: "My account",
  },

  intro: {
    settings: {
      title: "Settings",
      text: "Use the menu on the left. More will follow.",
    },
    module: {
      title: "Modules",
      text: "Use the menu on the left. More will follow.",
    },
  },
}
